// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.case-pagination-controls {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 5px 10px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}
.case-pagination-controls .pagination-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border: 1px solid #d0d0d0;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  background: #004A9A;
  color: white;
}
.case-pagination-controls .pagination-arrow:hover:not(:disabled) {
  background: white;
  color: #004A9A;
  border-color: #004A9A;
  transform: scale(1.05);
}
.case-pagination-controls .pagination-arrow:active:not(:disabled) {
  transform: scale(0.98);
}
.case-pagination-controls .pagination-arrow:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}
.case-pagination-controls .pagination-display {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 500;
  color: #333;
  min-width: 80px;
  justify-content: center;
}
.case-pagination-controls .pagination-display .current-index {
  color: #004A9A;
  font-weight: 600;
  font-size: 14px;
}
.case-pagination-controls .pagination-display .separator {
  color: #666;
  font-weight: 400;
  font-size: 13px;
}
.case-pagination-controls .pagination-display .total-cases {
  color: #666;
  font-weight: 500;
}

@media (max-width: 768px) {
  .case-pagination-controls {
    padding: 4px 8px;
    gap: 8px;
  }
  .case-pagination-controls .pagination-arrow {
    width: 28px;
    height: 28px;
  }
  .case-pagination-controls .pagination-display {
    font-size: 12px;
    min-width: 70px;
  }
  .case-pagination-controls .pagination-display .current-index {
    font-size: 13px;
  }
  .case-pagination-controls .pagination-display .separator {
    font-size: 11px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/CasePaginationControls/CasePaginationControls.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,yCAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;AACJ;AAGI;EACE,iBAAA;EACA,cAAA;EAGA,qBAAA;EACA,sBAAA;AAHN;AAMI;EACE,sBAAA;AAJN;AAOI;EACE,YAAA;EACA,mBAAA;AALN;AASE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,uBAAA;AAPJ;AASI;EACE,cAAA;EACA,gBAAA;EACA,eAAA;AAPN;AAUI;EACE,WAAA;EACA,gBAAA;EACA,eAAA;AARN;AAWI;EACE,WAAA;EACA,gBAAA;AATN;;AAeA;EACE;IACE,gBAAA;IACA,QAAA;EAZF;EAcE;IACE,WAAA;IACA,YAAA;EAZJ;EAeE;IACE,eAAA;IACA,eAAA;EAbJ;EAeI;IACE,eAAA;EAbN;EAgBI;IACE,eAAA;EAdN;AACF","sourcesContent":[".case-pagination-controls {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  padding: 5px 10px;\r\n  background: #f8f9fa;\r\n  border-radius: 8px;\r\n  border: 1px solid #e0e0e0;\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\r\n\r\n  .pagination-arrow {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 16px;\r\n    height: 16px;\r\n    border: 1px solid #d0d0d0;\r\n    border-radius: 6px;\r\n    cursor: pointer;\r\n    transition: all 0.2s ease;\r\n    background: #004A9A;\r\n    color: white;\r\n    //  background: white;\r\n    // color: #004A9A;\r\n\r\n    &:hover:not(:disabled) {\r\n      background: white;\r\n      color: #004A9A;\r\n      // background: #004A9A;\r\n      // color: white;\r\n      border-color: #004A9A;\r\n      transform: scale(1.05);\r\n    }\r\n\r\n    &:active:not(:disabled) {\r\n      transform: scale(0.98);\r\n    }\r\n\r\n    &:disabled {\r\n      opacity: 0.3;\r\n      cursor: not-allowed;\r\n    }\r\n  }\r\n\r\n  .pagination-display {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 6px;\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    color: #333;\r\n    min-width: 80px;\r\n    justify-content: center;\r\n\r\n    .current-index {\r\n      color: #004A9A;\r\n      font-weight: 600;\r\n      font-size: 14px;\r\n    }\r\n\r\n    .separator {\r\n      color: #666;\r\n      font-weight: 400;\r\n      font-size: 13px;\r\n    }\r\n\r\n    .total-cases {\r\n      color: #666;\r\n      font-weight: 500;\r\n    }\r\n  }\r\n}\r\n\r\n// Mobile responsive\r\n@media (max-width: 768px) {\r\n  .case-pagination-controls {\r\n    padding: 4px 8px;\r\n    gap: 8px;\r\n\r\n    .pagination-arrow {\r\n      width: 28px;\r\n      height: 28px;\r\n    }\r\n\r\n    .pagination-display {\r\n      font-size: 12px;\r\n      min-width: 70px;\r\n\r\n      .current-index {\r\n        font-size: 13px;\r\n      }\r\n\r\n      .separator {\r\n        font-size: 11px;\r\n      }\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
